export default __webpack_public_path__ + "static/threeGreenLines01-b33169f80f4f4021bf5815c4bda18739.svg";